import { useState, useRef, useEffect } from "react";
import { ChevronDown, Check } from "lucide-react";
import { LANGS } from "../i18n";
import { useLocale } from "../i18n/LocaleContext";

export function LanguageSwitcher({ dark = false }) {
  const { lang, switchLang, t } = useLocale();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  const current = LANGS.find((l) => l.code === lang);
  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        data-testid="language-switcher"
        aria-label={t("header.languageLabel")}
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
        className={`flex items-center gap-2 text-[11px] font-label uppercase tracking-[0.25em] transition-colors ${dark ? "text-imperium-champagne hover:text-imperium-white" : "text-imperium-brown hover:text-imperium-gold"}`}
      >
        {current.short}
        <ChevronDown className={`h-3.5 w-3.5 transition-transform duration-300 ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div
          data-testid="language-dropdown"
          className="absolute right-0 top-full z-50 mt-4 w-56 border border-imperium-champagne/40 bg-imperium-white py-2 shadow-[0_24px_60px_-24px_rgba(48,37,31,0.35)]"
        >
          {LANGS.map((l) => (
            <button
              key={l.code}
              type="button"
              data-testid={`language-option-${l.code}`}
              onClick={() => { switchLang(l.code); setOpen(false); }}
              className={`flex w-full items-center justify-between px-5 py-2.5 text-left text-sm transition-colors hover:bg-imperium-offwhite ${l.code === lang ? "text-imperium-bronze" : "text-imperium-black/80"}`}
            >
              <span className="flex items-baseline gap-3">
                <span className="w-9 text-[10px] font-label uppercase tracking-[0.2em] text-imperium-bronze/70">{l.short}</span>
                <span>{l.label}</span>
              </span>
              {l.code === lang && <Check className="h-3.5 w-3.5 text-imperium-gold" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
